







































import {
  Vue, Component, Prop, Watch, Mixins, Emit, InjectReactive,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend, clone,
} from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import firebase from 'firebase'
import dayjs from 'dayjs'
// import { vueVimeoPlayer } from 'vue-vimeo-player'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
// Filter Functions

const DisplayBoardCollection = collection<DisplayBoardType>('displayBoards')
const DisplaySlideCollection = collection<DisplaySlideType>('displaySlides')

@Component({
  components: {
    // vueVimeoPlayer,
    CDatePicker,
  },
})

export default class SingleBoard<T extends Vue> extends Mixins(MainMixin) {
  @Prop() data!: DisplayBoardType

  @Prop({ default: [] }) slides!: DisplaySlideType[]

  @Emit()
  makeactive (slide: DisplaySlideType) {
    return slide
  }

  @Emit()
  display (x: string, y: string) {
    return [x, y]
  }

  imageErrorCount = 0

  imageKey = 0

  refreshImage (index: number) {
    console.log('error loading image')
    if (this.imageErrorCount > 6) return false
    setTimeout(() => {
      this.imageKey += 1
      this.imageErrorCount += 1
    }, 1500)
    return true
  }

  showList = true

  listUpdated = false

  up (index: number) {
    if (index !== 0) {
      this.listUpdated = true
      const { slideList } = this
      const middle = slideList.splice(index, 1)
      const start = slideList.splice(0, index - 1)
      this.slideList = start.concat(middle).concat(slideList)
    }
  }

  down (index: number) {
    if (index !== this.slideList.length - 1) {
      this.listUpdated = true
      const { slideList } = this
      const middle = slideList.splice(index, 1)
      const start = slideList.splice(0, index + 1)
      this.slideList = start.concat(middle).concat(slideList)
    }
  }

  get allSlides (): DisplaySlideType[] {
    const slides: DisplaySlideType[] = []
    this.slideList.forEach((slideId: string) => {
      const foundSlide = this.slides.find(x => x.id === slideId)
      if (foundSlide && foundSlide.active) slides.push(foundSlide)
    })
    return slides
  }

  slideList = clone(this.data.slides)

  resetList () {
    this.slideList = clone(this.data.slides)
    this.listUpdated = false
  }

  orderLoading = false

  async saveListOrder () {
    this.orderLoading = true
    await db.collection('displayBoards').doc(this.data.id).update({
      slides: this.slideList,
    })
    this.$toast.success('Slide Order Updated')
    this.listUpdated = false
    this.orderLoading = false
  }

  @Watch('data', { deep: true })
  dataUpdated (newData: DisplayBoardType, oldData: DisplayBoardType) {
    if (newData.slides.length > oldData.slides.length) {
      this.resetList()
    }
  }
}

